import React, { useState } from 'react';
import Page from '../../components/page';
import { Stepper, StepProps, useSteps } from '@orbita-ui/core';
import FirstStep from './components/first-step';
import SecondStep from './components/second-step';
import ThirdStep from './components/third-step';
import { ICardHolder } from '../../interfaces/card-holder';
import { ICard } from '../../interfaces/card';
import { ITransaction } from '../../interfaces/transactions';
import FourthStep from './components/fourth-step';

export type FirstStepFormInputs = {
  cardHolder: ICardHolder;
};

export type SecondStepFormInputs = {
  card: ICard
};

export type ThirdStepFormInputs = {
  transaction: ITransaction[]
};

const ClaimNew = () => {
  const [firstStepData, setFirstStepData] = useState<FirstStepFormInputs | null>(null);
  const [secondStepData, setSecondStepData] = useState<SecondStepFormInputs | null>(null);
  const [thirdStepData, setThirdStepData] = useState<ThirdStepFormInputs | null>(null);

  const steps: StepProps[] = [
    {
      label: 'Titular',
      icon: 'UserIcon',
    },
    {
      label: 'Tarjeta',
      icon: 'NameTagIcon',
    },
    {
      label: 'Transacciones',
      icon: 'ListAddIcon',
    },
    {
      label: 'Resumen',
      icon: 'AddIcon',
    },
  ];

  const { activeStep, goToPrevious, goToNext } = useSteps({
    count: steps.length,
    index: 0,
  });

  return (
    <Page title={"Nuevo reclamo"}>
      <Stepper activeStep={activeStep} steps={steps} />
      {activeStep === 0 && <FirstStep   goToNext={goToNext} setFirstStepData={setFirstStepData} setSecondStepData={setSecondStepData} firstStepData={firstStepData}/>}
      {activeStep === 1 && (
        <SecondStep {...{ goToNext, goToPrevious, setSecondStepData, firstStepData, secondStepData }} />
      )}
      {activeStep === 2 && <ThirdStep {...{ goToNext, goToPrevious, firstStepData, secondStepData, thirdStepData, setThirdStepData }} />}
      {activeStep === 3 && <FourthStep {...{ goToPrevious, firstStepData, secondStepData, thirdStepData }} />}
    </Page>
  );
}

export default ClaimNew;